import { FeedItem } from '@knocklabs/client'
import { Routes } from '@scalis/routes'
import { NOTIFICATION_VARIABLES_WITH_LINK } from '../navbar-notifications-drawer-item.constants'
import { NOTIFICATION_VARIABLES_WITH_LINK_TYPE } from '../navbar-notifications-drawer-item.types'

export const isNotificationVariableWithLink = (
  variableName: string,
): variableName is NOTIFICATION_VARIABLES_WITH_LINK_TYPE =>
  NOTIFICATION_VARIABLES_WITH_LINK.includes(variableName as NOTIFICATION_VARIABLES_WITH_LINK_TYPE)

export const getRichLinkHref = (variableName: string, notification: FeedItem) => {
  switch (variableName) {
    case 'candidateName':
      return Routes.company.candidate({ candidateProfileId: notification.data?.candidateId })
    case 'jobTitle':
      return Routes.job_listing.view({ requisitionId: notification.data?.requisitionId })
    default:
      return ''
  }
}
